<div class="min-h-screen bg-gray-900">
    <nav class="fixed z-10 w-full bg-gray-800">
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="flex items-center justify-between h-16">
                <div class="flex items-center">
                    <div class="sm:ml-6">
                        <div class="flex">
                            <ng-container *ngFor="let item of mainMenu">
                                <a
                                    *ngIf="item.condition | async"
                                    [routerLink]="item.route"
                                    routerLinkActive="menu-active"
                                    class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-300 transition duration-150 ease-in-out rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                                    >{{ item.title }}</a
                                >
                                <a
                                    *ngIf="item?.isLink"
                                    [href]="item.link"
                                    target="_blank"
                                    class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-300 transition duration-150 ease-in-out rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                                    >{{ item.title }}</a
                                >
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="sm:ml-6 sm:block">
                    <div class="flex items-center">
                        <div class="flex ml-3 text-gray-300" *ngIf="userService.user$ | async as user">
                            <div
                                class="flex items-center text-sm hover:text-white focus:outline-none focus:text-white focus:bg-gray-700"
                            >
                                <p>{{ user.name }}</p>
                            </div>

                            <button
                                class="-ml-2 outline-none hover:text-white focus:outline-none focus:text-white focus:bg-gray-700"
                                mat-icon-button
                                [matMenuTriggerFor]="settings"
                            >
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <mat-menu #settings="matMenu">
                                <ng-container *ngFor="let item of settingsMenu; let last = last">
                                    <a mat-menu-item *ngIf="item.condition | async" (click)="item.click()">
                                        <mat-icon class="text-gray-300">{{ item.icon }}</mat-icon>
                                        <span
                                            class="pr-2 text-base text-gray-300 hover:text-white focus:outline-none focus:text-white"
                                            >{{ item.title }}</span
                                        >
                                    </a>
                                    <mat-divider *ngIf="(item.condition | async) && !last"></mat-divider>
                                </ng-container>
                            </mat-menu>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <div class="text-white pt-14">
        <router-outlet></router-outlet>
    </div>
</div>
